export default __webpack_public_path__ + "static/chart-34215b9380876d1ef8bebb633b6a9eb8.png";